<!-- ===== MODUS-AUSWAHL (noch nicht konfiguriert) ===== -->

@if (this.fusionService.selectedHtmlPage && (!this.fusionService.selectedHtmlPage.metadata.proxyUrl && !this.fusionService.selectedHtmlPage.metadata.useStaticHtml)) {
  @if (!this.showUrlInput) {
    <div>
      <p>
        <b i18n="@@html-media-embed">HTML-Inhalt einbinden</b><br>
        <span i18n="@@html-media-choose-mode">
        Wie soll der HTML-Inhalt bereitgestellt werden?
      </span>
      </p>
      <div class="row g-3">
        <div class="col-6">
          <div
            class="card mode-card h-100 text-center p-4"
            (click)="this.fusionService.updateFusionField('useStaticHtml', true)"
            >
            <div>
              <i class="ri-code-s-slash-line ri-3x text-primary"></i>
            </div>
            <h6
              class="mt-2 mb-1"
              i18n="@@html-media-mode-custom-title"
            >HTML selber eintragen</h6>
            <p
              class="text-secondary small mb-0"
              i18n="@@html-media-mode-custom-desc"
              >
            Den HTML-Inhalt direkt im Editor anlegen und bearbeiten.
            So hast du die volle Kontrolle über den angezeigten Inhalt.
          </p>
          </div>
        </div>
        <div class="col-6">
          <div
            class="card mode-card h-100 text-center p-4"
            (click)="this.showUrlInput = true"
            >
            <div>
              <i class="ri-global-line ri-3x text-primary"></i>
            </div>
            <h6
              class="mt-2 mb-1"
              i18n="@@html-media-mode-iframe-title"
            >Externe Seite via iframe laden</h6>
            <p
              class="text-secondary small mb-0"
              i18n="@@html-media-mode-iframe-desc"
              >
            Eine externe Webseite per URL einbinden und im iframe anzeigen.
            Änderungen an der Quellseite werden automatisch übernommen.
          </p>
          </div>
        </div>
      </div>
    </div>
  }
  @if (this.showUrlInput) {
    <div>
      <p-button
        [text]="true"
        severity="secondary"
        icon="ri-arrow-left-s-line"
        (onClick)="this.showUrlInput = false"
        i18n-label="@@back-to-mode-selection"
        label="Zurück zur Auswahl"
      ></p-button>
      <div class="mt-3">
        <h6 i18n="@@html-media-url-heading">Externe Seite einbinden</h6>
        <p
          class="text-secondary mb-3"
          i18n="@@html-media-url-description"
          >
        Gib die URL einer externen Webseite ein, die per iframe eingebunden werden soll.
        Die Seite wird bei jedem Aufruf direkt von der angegebenen Adresse geladen.
      </p>
        <label
          class="form-label fw-semibold"
          for="proxyUrlInput"
          i18n="@@html-media-url-label"
        >Seiten-URL</label>
        <input
          pInputText
          id="proxyUrlInput"
          #urlInput
          type="text"
          class="w-100"
          placeholder="https://example.com"
          />
        <div class="mt-3">
          <p-button
            styleClass="me-2"
            size="small"
            severity="primary"
            icon="ri-link"
            (onClick)="this.addURL(urlInput.value)"
            i18n-label="@@html-media-use-url"
            label="Externe Seite verwenden"
          ></p-button>
        </div>
      </div>
    </div>
  }
}

<!-- ===== KONFIGURIERTER ZUSTAND (URL oder Custom HTML) ===== -->
@if (this.fusionService.selectedHtmlPage && (this.fusionService.selectedHtmlPage.metadata.proxyUrl || this.fusionService.selectedHtmlPage.metadata.useStaticHtml)) {
  <!-- Modus-Anzeige -->
  <div class="mode-indicator d-flex justify-content-between align-items-center mb-3">
    @if (!this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
      <span>
        <i class="ri-global-line me-2"></i>
        <b i18n="@@html-media-current-mode-iframe">Modus: Externe Seite (iframe)</b>
      </span>
    }
    @if (this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
      <span>
        <i class="ri-code-s-slash-line me-2"></i>
        <b i18n="@@html-media-current-mode-custom">Modus: Eigenes HTML</b>
      </span>
    }
    <p-button
      size="small"
      [text]="true"
      severity="secondary"
      icon="ri-refresh-line"
      (onClick)="this.resetMode()"
      i18n-label="@@change-mode"
      label="Modus wechseln"
    ></p-button>
  </div>
  <!-- ===== TITEL + IDENTIFIKATOR ===== -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        for="pvTitle"
        i18n="@@title"
        (click)="$event.stopPropagation()"
      >Titel</label>
    </div>
    <div class="col">
      <input
        pInputText
        id="pvTitle"
        type="text"
        pSize="small"
        [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.title"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.fusionService.updateFusionFieldFor(this.fusionService.selectedHtmlPage._id, 'title', this.fusionService.selectedHtmlPage.metadata.title)"
        >
      <small class="text-muted mt-1 d-block">
        <span i18n="@@fusion-view-name">Identifikator</span>: {{ this.fusionService.selectedHtmlPage.metadata.name }}
      </small>
    </div>
  </div>
  <!-- iFrame-Vorschau (nur URL-Modus) -->
  @if (!this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
    <div>
      <p
        class="text-secondary mb-2"
        i18n="@@html-media-iframe-preview-desc"
        >
      Diese externe Seite wird per iframe eingebunden.
    </p>
      <div class="row">
        <div class="col">
          @if (this.safeHtml !== "") {
            <iframe [src]="this.safeHtml"></iframe>
          }
        </div>
      </div>
      <p-button
        styleClass="mt-2"
        size="small"
        [outlined]="true"
        severity="primary"
        icon="ri-file-copy-line"
        (onClick)="this.loadURL(this.fusionService.selectedHtmlPage.metadata.proxyUrl)"
        i18n-label="@@adopt-for-custom-editing"
        label="Für die individuelle Bearbeitung übernehmen"
      ></p-button>
    </div>
  }
  <!-- Bot-Typ -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        for="pvBotTypeSelect"
        i18n="@@fusionconfig-bottype"
        (click)="$event.stopPropagation()"
        >
        Bot-Typ
      </label>
    </div>
    <div class="col">
      <p-select
        id="pvBotTypeSelect"
        [options]="this.botTypeOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.bottype"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.fusionService.updateFusionField('bottype', this.fusionService.selectedHtmlPage.metadata.bottype)"
      ></p-select>
    </div>
  </div>
  <!-- Position -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        for="pvBotPosition"
        i18n="@@fusion-view-position"
        (click)="$event.stopPropagation()"
      >Position</label>
    </div>
    <div class="col">
      <input
        pInputText
        id="pvBotPosition"
        type="number"
        pSize="small"
        min="1"
        [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.sortFloat"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.fusionService.updateFusionField('sortFloat',this.fusionService.selectedHtmlPage.metadata.sortFloat)"
        >
    </div>
  </div>
  <!-- Systemsprache -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        for="pvLangSelect"
        i18n="@@fusionconfig-systemlang-label"
        (click)="$event.stopPropagation()"
        >
        Systemsprache
      </label>
    </div>
    <div class="col">
      <p-select
        id="pvLangSelect"
        [options]="this.systemLanguageOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.botlang"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.fusionService.updateFusionField('botlang', this.fusionService.selectedHtmlPage.metadata.botlang)"
      ></p-select>
    </div>
  </div>
  <!-- Custom JavaScript -->
  <div class="row py-1">
    <div class="col">
      <span
        class="text-secondary me-2 col col-form-label"
        i18n="@@fusionconfig-customjs"
        >
        Custom JavaScript
      </span>
    </div>
    <div class="col">
      <p-button
        [outlined]="true"
        severity="primary"
        [gotoBlockly]="this.editorItemService.getEditorItemByUniqueId('fusion_' + this.fusionService.selectedHtmlPage._id )"
        i18n-label="@@to-scripting"
        label="Zum Scripting"
      ></p-button>
    </div>
  </div>
  <!-- Bot ausblenden -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        i18n="@@fusionconfig-bot-hidden"
      >Bot ausblenden</label>
    </div>
    <div class="col">
      <p-toggleswitch
        [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.botHidden"
        (onChange)="this.fusionService.updateFusionField('botHidden', this.fusionService.selectedHtmlPage.metadata.botHidden)"
      ></p-toggleswitch>
    </div>
  </div>
  <!-- Bot-Button ausblenden -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        i18n="@@fusionconfig-bot-button-hidden"
      >Bot-Button ausblenden</label>
    </div>
    <div class="col">
      <p-toggleswitch
        [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.botButtonHidden"
        (onChange)="this.fusionService.updateFusionField('botButtonHidden', this.fusionService.selectedHtmlPage.metadata.botButtonHidden)"
      ></p-toggleswitch>
    </div>
  </div>

  <!-- Disclaimer-Platzierung -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        i18n="@@fusionconfig-disclaimer-over-fusionview"
      >Disclaimer über Fusion-View</label>
    </div>
    <div class="col">
      <p-toggleswitch
        [ngModel]="this.fusionService.selectedHtmlPage.metadata.disclaimerPlacement === 'fusionview'"
        (ngModelChange)="this.fusionService.selectedHtmlPage.metadata.disclaimerPlacement = $event ? 'fusionview' : 'botview'; this.fusionService.updateFusionField('disclaimerPlacement', this.fusionService.selectedHtmlPage.metadata.disclaimerPlacement)"
      ></p-toggleswitch>
    </div>
  </div>

  <!-- Ansichtsmodus -->
  <div class="row py-1">
    <div class="col">
      <label
        class="text-secondary me-2 col col-form-label"
        i18n="@@fusionconfig-view-mode"
      >Ansichtsmodus</label>
    </div>
    <div class="col">
      <p-select
        [options]="this.viewModeOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="this.fusionService.selectedHtmlPage.metadata.viewMode"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.fusionService.updateFusionField('viewMode', this.fusionService.selectedHtmlPage.metadata.viewMode)"
      ></p-select>
    </div>
  </div>
  <!-- HTML-Editor (nur Custom-HTML-Modus) -->
  @if (this.fusionService.selectedHtmlPage.metadata.useStaticHtml) {
    <label
      class="text-secondary me-2 col col-form-label"
      for="html"
      i18n="@@fusionconfig-html"
      (click)="$event.stopPropagation()"
    >HTML</label>
    <app-codemirror-html
      [code]="this.fusionService.selectedHtmlPage.metadata.staticHtml"
      (finish)="this.fusionService.selectedHtmlPage.metadata.staticHtml = $event.code; this.fusionService.updateFusionField('staticHtml', this.fusionService.selectedHtmlPage.metadata.staticHtml)"
    ></app-codemirror-html>
    <button
      pButton
      i18n-label="@@show-placeholders"
      label="Platzhalter anzeigen"
      icon="pi pi-info-circle"
      severity="secondary"
      size="small"
      class="mt-2"
      [appPlaceholderInfo]="'full'"
    ></button>
  }
}